import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileHref',
    standalone: false
})
export class FileHrefPipe implements PipeTransform {

    public transform(value: string): string {
        return 'file:///\\' + value;
    }
}
